import { PublishIncentiveOfferModalContextType } from '../types/PublishIncentiveOfferModalContextType';

export const publishIncentiveOfferModalInitValue: PublishIncentiveOfferModalContextType =
  {
    data: {
      modalActionType: '',
      incentiveOffer: null,
      publishedOffer: null,
      validityDays: 0,
      isTermsAndConditionsAccepted: false,
      isPurchaseContractAccepted: false,
      isHideSellerName: false,
      isLoading: true,
      currentStep: 1,
      publisherPartner: null,
      publisherDocuments: [],
      emailSubsidiary: '',
    },
    actions: {
      handleCloseModal: () => {},
      handleNextStep: () => {},
      handlePrevStep: () => {},
      handleChangeTermsAndConditionsAcceptance: () => {},
      handleChangePurchaseContractAcceptance: () => {},
      handleChangeHideSellerName: () => {},
      handleAddPublisherDocument: () => {},
      handleRemovePublisherDocument: () => {},
      handleUpdatePublisherPartnerField: () => {},
      handleUpdatePublisherPartnerAddressField: () => {},
      handleUpdateEmailSubsidiary: () => {},
      handlePublishIncentiveOffer: async () => {},
    },
  };
